var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcBlankImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 900,
    viewBox: "0 0 900 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_616_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.063 589.559C293.977 589.559 263.656 567.734 252.646 535.242L251.902 532.794C249.305 524.19 248.217 516.954 248.217 509.714V364.541L196.563 536.966C189.92 562.327 205.059 588.62 230.459 595.626L559.701 683.799C563.811 684.863 567.92 685.374 571.967 685.374C593.172 685.374 612.548 671.3 617.979 650.559L637.161 589.559H328.063Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.618 365.991C410.104 365.991 429.2 346.892 429.2 323.406C429.2 299.92 410.104 280.82 386.618 280.82C363.132 280.82 344.032 299.92 344.032 323.406C344.032 346.892 363.132 365.991 386.618 365.991Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.768 216.944H333.385C304.047 216.944 280.156 240.835 280.156 270.177V504.388C280.156 533.73 304.047 557.621 333.385 557.621H652.768C682.11 557.621 706.001 533.73 706.001 504.388V270.177C706.001 240.835 682.11 216.944 652.768 216.944V216.944ZM333.385 259.529H652.768C658.647 259.529 663.415 264.297 663.415 270.177V421.33L596.155 342.845C589.02 334.478 578.692 330.006 567.6 329.753C556.571 329.815 546.224 334.712 539.155 343.188L460.074 438.106L434.311 412.406C419.749 397.844 396.049 397.844 381.507 412.406L322.741 471.152V270.177C322.741 264.297 327.51 259.529 333.385 259.529V259.529Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_616_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 511,
    height: 511,
    fill: "white",
    transform: "translate(195 195)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBlankImage);
export default __webpack_public_path__ + "static/media/ic_blank_image.f620a8ff4252b3d6888f6df39d4ddb14.svg";
export { ForwardRef as ReactComponent };